//项目相关的请求
import { request } from "@/utils";

//获取项目列表
export function getProjectListAPI() {
  return request({
    url: '/crostars-project/list',
    method: 'GET',
  })
}

//获取项目详细信息
export function getProjectDetailAPI(proejctId) {
  return request({
    url: `/crostars-project/detail?id=${proejctId}`,
    method: 'POST',
  })
}

//获取项目名称列表
export function getProjectNameAPI() {
  return request({
    url: `/crostars-project/list-with-name`,
    method: 'GET',
  })
}

//添加项目
export function addProjectAPI(projectForm) {
  return request({
    url: '/crostars-project/add',
    method: 'POST',
    data: projectForm
  })
}

//更新项目
export function updateProjectAPI(projectForm){
  return request({
    url: '/crostars-project/update',
    method: 'POST',
    data: projectForm
  })
}

//删除项目
export function deleteProjectAPI(id){
  return request({
    url: `/crostars-project/delete?projectId=${id}`,
    method: 'POST',
  })
}

// 取消项目
export function cancelProjectAPI(id){
  return request({
    url: `/crostars-project/cancel?projectId=${id}`,
    method: 'POST'
  })
}

//通过id获取项目
export function getProjectByIdAPI(id){
  return request({
    url: `/crostars-project/get-project-by-id?id=${id}`,
    method: 'POST',
  })
}

//通过id获取视频URL
export function getVideoUrlByIdAPI(id){
  return request({
    url: `/crostars-project/get-video-url-by-id?projectId=${id}`,
    method: 'POST',
  })
}


//通过项目名查询项目
export function getProjectByNameAPI(name){
  return request({
    url: `/crostars-project/get-project-by-project-name?projectName=${name}`,
    method: 'POST',
  })
}